import { AxiosPromise } from 'axios';
import axios from 'axios';
import {
  IEntranceExamineeReq,
  IEntranceScheduleByDateReq,
  IEntranceScheduleReq,
  IExamConditionReq,
  IGetEntranceDetail,
  IGetEntranceExaminees,
  IGetEntranceSchedules,
  IGetExamConditions,
  IGetExamineeDetail,
  IGetExamSubjects,
  IGetSpeakingTestInfo,
  IGetSurveyResult,
  ISpeakingTestResultReq,
  IStudentLevelReq,
} from '../models/placeTest.model';
import QueryString from 'qs';

const uri = '/mgmt/place-test';

export const getEntranceSchedules = (
  campusCode: string,
): AxiosPromise<IGetEntranceSchedules> => {
  return axios.get(`${uri}/schedule/SU/${campusCode}`);
};

export const getEntranceSchedulesByDate = (
  campusCode: string,
  params: IEntranceScheduleByDateReq,
): AxiosPromise<IGetEntranceSchedules> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/schedule/SU/${campusCode}/date?${qsParams}`);
};

export const createEntranceSchedule = (
  campusCode: string,
  data: IEntranceScheduleReq,
): AxiosPromise => {
  return axios.post(`${uri}/schedule/${campusCode}`, data);
};

export const updateEntranceSchedule = (
  campusCode: string,
  data: IEntranceScheduleReq,
): AxiosPromise => {
  return axios.put(`${uri}/schedule/${campusCode}`, data);
};

export const deleteEntranceSchedule = (
  platScheduleCode: number,
): AxiosPromise => {
  return axios.delete(`${uri}/schedule/${platScheduleCode}`);
};

export const changeEntranceSchedule = (
  platRequireCode: number,
  platScheduleCode: number,
): AxiosPromise => {
  return axios.put(
    `${uri}/require/detail/${platRequireCode}/move/${platScheduleCode}`,
  );
};

export const cancelEntranceExamWithoutRefund = (
  platRequireCode: number,
): AxiosPromise => {
  return axios.put(`${uri}/require/detail/${platRequireCode}/cancel`);
};

export const getEntranceExaminees = (
  campusCode: string,
): AxiosPromise<IGetEntranceExaminees> => {
  return axios.get(`${uri}/${campusCode}/require/student`);
};

export const getEntranceDetail = (
  platScheduleCode: number,
): AxiosPromise<IGetEntranceDetail> => {
  return axios.get(`${uri}/schedule/detail/${platScheduleCode}`);
};

export const createEntranceExaminee = (
  platScheduleCode: number,
  req: IEntranceExamineeReq,
): AxiosPromise => {
  return axios.post(`${uri}/require/${platScheduleCode}`, req);
};

export const getExamineeDetail = (
  platRequireCode: number,
): AxiosPromise<IGetExamineeDetail> => {
  return axios.get(`${uri}/require/detail/${platRequireCode}`);
};

export const openEvaluation = (platRequireCode: number): AxiosPromise => {
  return axios.put(`${uri}/require/detail/${platRequireCode}/evaluation`);
};

export const getSurveyResult = (
  platRequireCode: number,
): AxiosPromise<IGetSurveyResult> => {
  return axios.get(`${uri}/require/detail/${platRequireCode}/survey`);
};

export const getSpeakingTestInfo = (
  placeTestCode: number,
): AxiosPromise<IGetSpeakingTestInfo> => {
  return axios.get(`${uri}/speaking-exam/${placeTestCode}`);
};

export const submitSpeakingTestResult = (
  platRequireCode: number,
  data: ISpeakingTestResultReq[],
): AxiosPromise<IGetSpeakingTestInfo> => {
  return axios.post(`${uri}/speaking-exam/${platRequireCode}/evaluation`, data);
};

export const getExamConditions = (
  platRequireCode: number,
): AxiosPromise<IGetExamConditions> => {
  return axios.get(`${uri}/require/test-info/${platRequireCode}`);
};

export const updateExamConditions = (
  platRequireCode: number,
  data: IExamConditionReq,
): AxiosPromise => {
  return axios.put(`${uri}/require/test-info/${platRequireCode}`, data);
};

export const getExamSubjects = (
  examTestCode: number,
): AxiosPromise<IGetExamSubjects> => {
  return axios.get(`${uri}/require/detail/subject-score/${examTestCode}`);
};

export const updateStudentLevel = (
  platRequireCode: number,
  data: IStudentLevelReq,
): AxiosPromise => {
  return axios.put(`${uri}/require/detail/level/${platRequireCode}`, data);
};

export const updateCounselor = (
  platRequireCode: any,
  memberCode: any,
): AxiosPromise => {
  return axios.put(`${uri}/counselor/${platRequireCode}/${memberCode}`);
};
